import Vue from 'vue';
import SettingsMenu from '@/components/SettingsMenu.vue';
import UserMenu from '@/components/UserMenu.vue';
import { isEmbedMode } from '@/lib/embedMode';
export default Vue.extend({
    name: 'AppHeader',
    components: {
        SettingsMenu,
        UserMenu,
    },
    data() {
        return {
            spacerHeight: 0,
        };
    },
    computed: {
        // Task A6: hide nav chrome (user menu) inside the Sparkco iframe
        isEmbed() {
            return isEmbedMode();
        },
    },
    mounted() {
        this.updateSpacerHeight();
        window.addEventListener('resize', this.updateSpacerHeight);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.updateSpacerHeight);
    },
    methods: {
        updateSpacerHeight() {
            const header = this.$refs.header;
            if (header) {
                this.spacerHeight = header.offsetHeight;
                document.documentElement.style.setProperty('--app-header-height', header.offsetHeight + 'px');
            }
        },
    },
});
